import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

const CommonModal = ({
    open,
    setOpen,
    children,
    title,
}: {
    open: any;
    setOpen: any;
    children: React.ReactNode;
    title?: string;
}) => {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            PaperProps={{ sx: { minWidth: '500px' } }}
        >
            <DialogTitle className="flex flex-row justify-between items-center bg-gray-100">
                <div className="flex flex-row gap-3 items-center">
                    <p>{title}</p>
                </div>
                <CloseOutlinedIcon
                    onClick={() => setOpen(false)}
                    className="cursor-pointer"
                    sx={{ color: 'red' }}
                />
            </DialogTitle>

            <DialogContent className="mt-5 ">{children}</DialogContent>
        </Dialog>
    );
};

export default CommonModal;
